<template>
	<section class="posts-grid" v-if="posts && posts.length" :class="'type-' + posts[0].type">
		<div class="posts-line" v-if="type !== 'events'">
			<PostBlock v-for="post in posts" :key="post.id" :data="post" />
		</div>
		<div class="events-list" v-if="type === 'events'">
			<EventBlock v-for="post in posts" :key="post.id" :data="post" />
		</div>
	</section>
</template>

<script>
import PostBlock from '@/components/elements/PostBlock'
import EventBlock from '@/components/parts/EventBlock'

export default {
	name: 'posts-grid',
	props: {
		type: {
			type: String,
			default: 'post',
		},
		posts: {
			default: [],
		},
	},
	components: {
		PostBlock,
		EventBlock,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.posts-grid {
	&.type-events {
		.block {
			max-width: 100%;
		}
	}
}

.posts-line {
	display: flex;
	flex-wrap: wrap;
	margin-left: -25px;
	margin-right: -25px;
	min-width: 100%;
	justify-content: center;
	.block {
		width: 100%;
		max-width: 33.33%;
		padding-left: 25px;
		padding-right: 25px;
	}
	@include mquery($tablet) {
		margin-left: -12px;
		margin-right: -12px;
		.block {
			max-width: 33.33%;
			padding-left: 12px;
			padding-right: 12px;
		}
	}
	@include mquery($phone) {
		.block {
			max-width: 100%;
		}
	}
}
.posts-grid {
	padding: 0;
	&.list-grid {
		@media screen and (min-width: $phone) {
			max-width: 950px;
			margin-left: auto;
			margin-right: auto;
			.posts-line {
				flex-direction: column;
				.block {
					max-width: 100%;
					min-width: 100%;
				}
				.post-link {
					display: flex;
					width: 100%;
					.inner {
						padding: 50px;
						width: 100%;
					}
					.head-block {
						min-width: 363px;
						max-width: 363px;
						min-height: 205px;
						div.image {
							border-top-right-radius: 0;
							border-bottom-left-radius: $radius;
						}
					}
				}
			}
		}
	}
	.block {
		margin-bottom: 50px;
		@include mquery($tablet) {
			margin-bottom: 30px;
		}
		@include mquery($phone) {
			margin-bottom: 20px;
		}
	}
}
</style>
